import { EVERYONE_PRINCIPAL_ID } from '#validation/common/constants';
import { PrincipalProvider } from '#validation/principal';
export const GROUP_NAME_MIN_LENGTH = 1;
export const GROUP_NAME_MAX_LENGTH = 128;
export const EVERYONE_GROUP_NAME = 'Everyone';
export const GROUP_NAME_START_REGEX = /^[\w#.@-]/;
export const GROUP_NAME_END_REGEX = /[\w#.@-]$/;
export const GROUP_NAME_COMMON_REGEX = /^[\w #.@-]+$/;
export const EVERYONE_GROUP = {
    id: EVERYONE_PRINCIPAL_ID,
    name: EVERYONE_GROUP_NAME,
    provider: PrincipalProvider.LUCID,
};
